import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import { getToken } from '../components/Token';
import { clearLocalStorage } from '../utils/common';
import { getTenantHeaders } from '../components/TenantHeaders';

export class RoleStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      roles: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.roles = [];
  }

  async setData(task, data, getRole = true) {
    this[task] = data;
    if (getRole) {
      this.getRole(this.offset, this.limit, this.search, this.sort, this.order);
    }
  }

  async getRole(offset = 0, limit = 15, search = null, sort = null, order = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/role`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const roles = res.body || {};
        return (this.roles = roles);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteRole(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/role/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createRole(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        description: data.description,
      };
      let url = `${config.api.url}/${config.api.version}/role`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateRole(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        description: data.description,
      };
      let url = `${config.api.url}/${config.api.version}/role/${data.id}`;
      const res = await rp
        .put(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new RoleStore();
